<div class="page-shell">
  <div class="signature-page-header-shell">
    <header class="signature-page-header">
      <h1 class="signature-page-header__title">
        {{ footer?.name || ("footers.preview" | translate) }}
      </h1>

      <div class="signature-page-header__controls">
        <div class="signature-page-header__switch">
          <span class="switch-info">{{ 'footers.installSelect' | translate }}</span>
          <div class="switch">
            <input
              id="switch-out"
              name="tripple"
              type="radio"
              value="out"
              class="switch-input"
              [checked]="installationMode === 'ext'"
              (change)="onRadioChange('ext')"
              [disabled]="loading || !preview"
            />
            <label for="switch-out" class="switch-label switch-label-out">
              {{ 'external' | translate }}
            </label>

            <input
              id="switch-in"
              name="tripple"
              type="radio"
              value="in"
              class="switch-input"
              [checked]="installationMode === 'int'"
              (change)="onRadioChange('int')"
              [disabled]="loading || !preview"
            />
            <label for="switch-in" class="switch-label switch-label-in">
              {{ 'internal' | translate }}
            </label>

            <input
              id="switch-both"
              name="tripple"
              type="radio"
              value="both"
              class="switch-input"
              [checked]="installationMode === 'all'"
              (change)="onRadioChange('all')"
              [disabled]="loading || !preview"
            />
            <label for="switch-both" class="switch-label switch-label-both">
              {{ 'all' | translate }}
            </label>

            <span class="switch-selector" #selectorEl></span>
          </div>
        </div>

        <div class="signature-page-header__actions">
          <a mat-raised-button [routerLink]="['edit']" [disabled]="loading || updating">
            {{ 'footers.edit' | translate }}
          </a>
          <a mat-raised-button [disabled]="loading || updating" (click)="setForMe()">
            <mat-spinner *ngIf="updating" diameter="20" class="dc-btn-spinner"></mat-spinner>
            {{ 'footers.installForMe' | translate }}
          </a>
          <a mat-raised-button [disabled]="loading || updating" (click)="setForAll()">
            <mat-spinner *ngIf="updating" diameter="20" class="dc-btn-spinner"></mat-spinner>
            {{ (updating ? 'footers.setting' : 'footers.installAll') | translate }}
          </a>
        </div>
      </div>
    </header>
  </div>

  <div class="signature-details-content">
    <div *ngIf="footerModifiedAt" class="modify-date">
      {{ 'modifiedAt' | translate }}: {{ footerModifiedAt | localizedDate:'medium' }}
    </div>

    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>{{ 'footers.preview' | translate }}</mat-card-title>
      </mat-card-header>
      <mat-card-content class="preview-wrapper">
        <div *ngIf="sanitizedContent" class="preview" [innerHTML]="sanitizedContent"></div>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>{{ 'footers.installForUser' | translate }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <app-submit-user
          #submitUserComponent [updating]="updating"
          (submitted)="setForUser($event)">
        </app-submit-user>
      </mat-card-content>
    </mat-card>


    <div class="mat-accordion-wrapper">
      <mat-accordion>
        <mat-expansion-panel (opened)="unitComponent.loadData()">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ 'footers.installForUnit' | translate }}</mat-panel-title>
          </mat-expansion-panel-header>
          <app-unit #unitComponent
                    [updating]="updating"
                    (clicked)="assignToUnit($event)">
          </app-unit>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <div class="mat-accordion-wrapper">
      <mat-accordion>
        <mat-expansion-panel (opened)="groupComponent.loadData()">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ 'footers.installForGroup' | translate }}</mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            <app-group #groupComponent
                       [updating]="updating"
                       [currentSignatureId]="footer?.templateId"
                       (clicked)="assignToGroup($event)"
                       (uninstall)="uninstallAllSignatures($event)"
                       (clickedAll)="assignToGroupWithAlias($event)"
                       [signatureName]="footer?.name"
            ></app-group>
          </p>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <div class="mat-accordion-wrapper">
      <mat-accordion>
        <mat-expansion-panel (opened)="branchComponent.loadData()">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ 'footers.installForBranch' | translate }}</mat-panel-title>
          </mat-expansion-panel-header>
          <app-install-branch #branchComponent
                              [updating]="updating"
                              (clicked)="assignToBranch($event)">
          </app-install-branch>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <div class="mat-accordion-wrapper" *ngIf="domainRulesEnabled && footer" id="domain-rules">
      <mat-accordion>
        <mat-expansion-panel #domainRulesPanel>
          <mat-expansion-panel-header>
            <mat-panel-title>{{ "footers.domainRules" | translate }}</mat-panel-title>
          </mat-expansion-panel-header>
          <app-signature-domain-rules
            [footer]="footer"
            [disabled]="updating"
            (changed)="refreshFooter()"
          ></app-signature-domain-rules>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <div class="actions">
      <button mat-raised-button (click)="goToSignatures()">
        {{ 'cancel' | translate }}
      </button>
      <!-- <a
        *ngIf="canDelete"
        mat-raised-button color="warn"
        (click)="delete()"
        [disabled]="deleting">
        {{ (deleting ? 'deleting' : 'delete') | translate }}
      </a> -->
    </div>

    <div class="dbc1-loading dbc1-loading--overlay" *ngIf="loading">
      <app-loading></app-loading>
    </div>
  </div>
</div>
